import { Users, Wallet, RefreshCw, Gift } from "lucide-react";

function Kpi({ label, value, caption, icon: Icon }) {
  const id = label.replace(/\s/g, "-").toLowerCase();
  return (
    <div className="rounded-2xl bg-white border border-[#0B0D10]/10 p-5" data-testid={`kpi-${id}`}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.16em] text-[#0B0D10]/50 font-semibold">{label}</span>
        <Icon size={15} strokeWidth={2} className="text-[#0B0D10]/35" />
      </div>
      <div className="font-display font-extrabold text-[32px] leading-none mt-4 tracking-[-0.03em] tabular-nums" data-testid={`stat-${id}`}>{(value || 0).toLocaleString()}</div>
      <div className="text-[12.5px] mt-2 text-[#0B0D10]/50">{caption}</div>
    </div>
  );
}

export function KpiStrip({ a }) {
  const pending = Math.max(0, (a.rewards_earned || 0) - (a.rewards_redeemed || 0));
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="kpi-strip">
      <Kpi label="Members" value={a.issued} caption={`${a.new_this_week || 0} new this week`} icon={Users} />
      <Kpi label="Wallet installs" value={a.installed} caption={`${a.install_rate}% of members`} icon={Wallet} />
      <Kpi label="Visits" value={a.visits} caption={`${a.repeat_rate}% came back`} icon={RefreshCw} />
      <Kpi label="Rewards redeemed" value={a.rewards_redeemed} caption={pending ? `${pending} ready to claim` : "None waiting"} icon={Gift} />
    </div>
  );
}
